<template>
  <v-flex v-bind="vflexProps">
    <list-filter
      v-model="getValue"
      :labels="$t(label)"
      @search="setSearch()"
    />
  </v-flex>
</template>

<script>
import ListFilter from 'Support/components/filters/ListFilter.vue';

export default {
  name: 'SearchFilter',
  components: {
    ListFilter,
  },
  props: {
    label: {
      type: String,
      default: 'support.components.searchLabel',
    },
    value: {
      type: String,
      required: true,
    },
    vflexProps: {
      type: Object,
      default() {
        return {
          xs4: true,
        };
      },
    },
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    setSearch() {
      this.$emit('search');
    },
  },
};
</script>
